import React from 'react';
import { CnProgress } from '@cainiaofe/cn-ui';
import { CnRankingProps } from './types';
import { CnRankingBase } from './base';

/**
 * @description 排行榜组件
 */
export const CnRanking = <T,>(props: CnRankingProps<T>) => (
  <CnRankingBase {...props} CnProgress={CnProgress} />
);

export default CnRanking;
